import { facilityAction, facilityStayAction, TherapistAction } from './constant';

const {
  GET_ASSIGNED_FACILITY_REQUEST,
  SWITCH_FACILITY_REQUEST,
  STORE_FACILITY_UUID,
  SWITCH_FACILITY_RESET,
  PRE_GET_ASSIGNED_FACILITY_REQUEST,
} = facilityAction;

const {
  REQUEST_GET_ALL_FACILITIES_STAY,
  REQUEST_UPDATE_FACILITY_STAY,
  REQUEST_CREATE_FACILITY_STAY,
  RESET_CREATE_FACILITY_STAY,
  REQUEST_GET_ALL_FACILITIES,
  RESET_UPDATE_FACILITY_STAY,
  RESET_GET_ALL_FACILITIES,
} = facilityStayAction;

const {
  THERAPIST_PROFILE_REQUEST,
  THERAPIST_PROFILE_RESET,
  PRE_THERAPIST_PROFILE_REQUEST,
  GET_PAYCOME_PROVIDER_REQUEST,
  GET_CLOCK_IN_OUT_BUTTON_VISIBILITY_REQUEST,
  GET_CLOCK_IN_OUT_BUTTON_VISIBILITY_SUCCESS,
  GET_CLOCK_IN_OUT_BUTTON_VISIBILITY_FAILURE,
} = TherapistAction;

interface UpdateFacilityStay {
  uuid: string;
  data: any;
}

export const getAssignedFacilities = () => {
  return {
    type: GET_ASSIGNED_FACILITY_REQUEST,
  };
};

export const switchFacilityAction = (uuid: string) => {
  return {
    type: SWITCH_FACILITY_REQUEST,
    uuid,
  };
};
export const switchFacilityResetAction = () => {
  return {
    type: SWITCH_FACILITY_RESET,
  };
};

export const storeFacilityUuid = (uuid: string) => {
  return {
    type: STORE_FACILITY_UUID,
    uuid,
  };
};

export const getAllFacilitiesStays = (uuid: string, params: any) => {
  return {
    type: REQUEST_GET_ALL_FACILITIES_STAY,
    uuid,
    params,
  };
};

export const resetFacilityListDropdown = () => {
  return {
    type: RESET_GET_ALL_FACILITIES,
  };
};

export const createFacilityStay = (payload: any) => {
  return {
    type: REQUEST_CREATE_FACILITY_STAY,
    payload,
  };
};

export const resetFacilityStay = () => {
  return {
    type: RESET_CREATE_FACILITY_STAY,
  };
};

export const resetEditFacilityStay = () => {
  return {
    type: RESET_UPDATE_FACILITY_STAY,
  };
};

export const updateFacilityStay = (payload: UpdateFacilityStay) => {
  return {
    type: REQUEST_UPDATE_FACILITY_STAY,
    payload,
  };
};

export const getTherapistProfileAction = () => {
  return {
    type: THERAPIST_PROFILE_REQUEST,
  };
};

export const getPayComeTherapistDetails = () => {
  return {
    type: GET_PAYCOME_PROVIDER_REQUEST,
  };
};

export const getClockInOutButtonVisibility = () => {
  return {
    type: GET_CLOCK_IN_OUT_BUTTON_VISIBILITY_REQUEST,
  };
};

export const setClockInOutButtonVisibilitySuccess = (isVisible: boolean) => {
  return {
    type: GET_CLOCK_IN_OUT_BUTTON_VISIBILITY_SUCCESS,
    payload: isVisible,
  };
};

export const setClockInOutButtonVisibilityFailure = () => {
  return {
    type: GET_CLOCK_IN_OUT_BUTTON_VISIBILITY_FAILURE,
  };
};

export const getFacility = (payload: object) => {
  return {
    type: REQUEST_GET_ALL_FACILITIES,
    payload,
  };
};

export const resetTherapistProfile = () => {
  return {
    type: THERAPIST_PROFILE_RESET,
  };
};

export const preGetAssignedFacilities = () => {
  return {
    type: PRE_GET_ASSIGNED_FACILITY_REQUEST,
  };
};

export const preGetTherapistProfileAction = () => {
  return {
    type: PRE_THERAPIST_PROFILE_REQUEST,
  };
};
